<template>
  <div
    v-if="!loading && !error"
    class="fou-type-trends-tips"
    data-qa-id="trends-tips-container"
  >
    <div class="fou-type-trends-tips__featured">
      <h2
        data-qa-id="trends-tips-content-title"
        class="fou-type-trends-tips__featured__title"
      >
        {{ content.title }}
      </h2>
      <p
        data-qa-id="trends-tips-p"
        class="fou-type-trends-tips__featured__para"
        v-html="$sanitize(content.description)"
      />
      <div
        v-if="content.image"
        data-qa-id="trends-tips-image"
        :style="bgImage"
      >
      <img :src="bgImage" class="image-right-sidebar" alt="trends tips img"/>
      </div>
      <MdButton :data-qa-id="learnMoreDataQaId" :disabled="!ufda2Status">
        <a :href="contentUrl(content.cta.ctaLink)" :target="anchorTarget" :class="'readmore-btn'">
          {{ content.cta.ctaText }}
        </a>
      </MdButton>
    </div>
  </div>
</template>

<script src="./script.js"></script>
